module.exports = __webpack_public_path__ + "img/face-recognition-error.65138514.svg";